import React, { useState } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { useAdminLayout } from "../contexts/AdminLayoutContext";
import { useLocation, Link, useNavigate } from "react-router-dom";

const AdminHeader = () => {
  const { openAddCourseModal } = useAdminLayout();
  const location = useLocation();
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const isCreateButtonVisible = location.pathname === "/courses";

  // Get user info from localStorage
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };

  const navItems = [
    { name: "Structure", path: "/structure" },
    { name: "Vision", path: "/vision" },
    { name: "Presentation", path: "/presentation" },
    { name: "Schedules", path: "/schedules" },
  ];

  return (
    <header className="flex items-center justify-between px-6 py-3 bg-white border-b border-gray-200">
      {/* Left section: Logo/Site Title and Create button */}
      <div className="flex items-center space-x-4">
        {/* Logo/Site Title Placeholder */}
        <div className="text-xl font-bold text-gray-900">iSyllabi</div>{" "}
        {/* Replace with actual logo/title */}
        {/* Create Button */}
        {/* {isCreateButtonVisible && (
          <button
            onClick={openAddCourseModal}
            className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
          >
            <PlusIcon className="-ml-1 mr-2 h-5 w-5" />
            Create
          </button>
        )} */}
      </div>

      {/* Middle section: Navigation Tabs */}
      <nav className="hidden md:flex space-x-8">
        {navItems.map((item) => (
          <Link
            key={item.name}
            to={item.path}
            className={`font-medium ${
              location.pathname === item.path
                ? "text-indigo-600"
                : "text-gray-500 hover:text-gray-900"
            }`}
          >
            {item.name}
          </Link>
        ))}
      </nav>

      {/* Right section: User Menu */}
      <div className="flex items-center space-x-4">
        {/* User Menu */}
        <div className="relative">
          <button
            onClick={() => setShowUserMenu(!showUserMenu)}
            className="flex items-center space-x-2 text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            <div className="w-8 h-8 rounded-full bg-indigo-600 flex items-center justify-center text-sm font-medium text-white">
              {user.firstName
                ? user.firstName.charAt(0) + user.lastName.charAt(0)
                : "U"}
            </div>
            <span className="hidden md:block text-gray-700">
              {user.firstName} {user.lastName}
            </span>
            <svg
              className="w-4 h-4 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          {showUserMenu && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
              <div className="px-4 py-2 text-sm text-gray-700 border-b">
                <div className="font-medium">
                  {user.firstName} {user.lastName}
                </div>
                <div className="text-gray-500">{user.email}</div>
                <div className="text-gray-500 capitalize">{user.role}</div>
              </div>
              <button
                onClick={handleLogout}
                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Sign out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
